import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode, useEffect } from "react";
import { createRoot } from "react-dom/client";
import { Toaster } from "sonner";
import { useTheme, watchSystemTheme } from "./lib/theme";
import { router } from "./router";
import "./styles.css";

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, refetchOnWindowFocus: false, retry: 1 } },
});

function App() {
  useEffect(() => watchSystemTheme(), []);
  const theme = useTheme((s) => s.resolved);
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} context={{ queryClient }} />
      <Toaster
        theme={theme}
        position="top-center"
        toastOptions={{
          style: { background: "var(--color-raised)", color: "var(--color-paper)", border: "1px solid var(--color-line)" },
        }}
      />
    </QueryClientProvider>
  );
}

const root = document.getElementById("root");
if (root) {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
